import { partnerClient } from '@/modules/core/services';
import {
  AvailableDatesParams,
  AvailableDatesResponse,
  AvailableTimeRangesParams,
  AvailableTimeRangesResponse,
  BookAppointmentProps,
  CancelAppointmentParams,
  CancelAppointmentPayload,
  CancelAppointmentResponse,
  DeclineReferralProps,
  EventTypeId,
  RegisterContactAttemptProps,
} from '../types';
import { ReopenAppointmentResponseValues } from '../types/reopen-appointment';

export const fetchAvailableDates = async (
  values: AvailableDatesParams,
): Promise<AvailableDatesResponse | undefined> => {
  const response = await partnerClient.post('appointments/get_available_dates', values);
  return response?.data;
};

export const fetchAvailableTimeRanges = async (
  values: AvailableTimeRangesParams,
): Promise<AvailableTimeRangesResponse | undefined> => {
  const response = await partnerClient.post('appointments/get_available_datetimes', values);
  return response?.data;
};

export const bookAppointment = async ({ id, values }: BookAppointmentProps): Promise<void> => {
  const response = await partnerClient.patch(`appointments/${id}`, values);
  return response?.data;
};

export const cancelAppointment = async (
  id: string,
  { reasonCode, reasonDescription, declinedReasonNotes }: CancelAppointmentParams,
): Promise<CancelAppointmentResponse> => {
  const payload: CancelAppointmentPayload = {
    event: EventTypeId.cancel,
    eventDateTime: new Date().toISOString(),
    reasonCode,
    reasonDescription,
    declinedReasonNotes,
  };
  return await partnerClient.patch(`appointments/${id}`, payload);
};

export const declineReferral = async ({ id, values }: DeclineReferralProps): Promise<void> => {
  const response = await partnerClient.patch(`appointments/${id}`, values);

  return response?.data;
};

export const registerContactAttempt = async ({ id, values }: RegisterContactAttemptProps): Promise<void> => {
  const response = await partnerClient.patch(`appointments/${id}`, values);

  return response?.data;
};

export const reopenAppointment = async (id: string): Promise<ReopenAppointmentResponseValues> => {
  return await partnerClient.patch(`appointments/${id}`, { event: EventTypeId.reopen });
};
